export const SET_ACTIVE_INDEX = '@app/carousel/setActiveIndex';
export const SHOW_PREVIOUS = '@app/carousel/showPrevious';
export const SHOW_NEXT = '@app/carousel/showNext';

export const setActiveIndexAction = (index) => ({
	type: SET_ACTIVE_INDEX,
	index
});

export const showPreviousAction = () => ({
	type: SHOW_PREVIOUS
});

export const showNextAction = () => ({
	type: SHOW_NEXT
});



// WEBPACK FOOTER //
// ./actions/CarouselActions.js